import * as tslib_1 from "tslib";
import { AfterViewInit, ElementRef, ViewContainerRef } from '@angular/core';
import Hls from 'hls.js';
import { environment } from '../../../environment';
import { InputConverter, JSONConverter } from '../../../inputConverter';
import { DocumentService } from '../../../services/document.service';
import { BaseComponent } from '../../base.component';
var DocSourceVideoComponent = /** @class */ (function (_super) {
    tslib_1.__extends(DocSourceVideoComponent, _super);
    function DocSourceVideoComponent(_vcr, documentService) {
        var _this = _super.call(this, _vcr) || this;
        _this.documentService = documentService;
        _this.showCameraVideo = true;
        return _this;
    }
    Object.defineProperty(DocSourceVideoComponent.prototype, "document", {
        get: function () {
            return this._document;
        },
        set: function (value) {
            if (window.environment.indexOf('internal') === -1 && value && value.thumbnail && value.thumbnail.indexOf('thumbs') > -1 && value.thumbnail.toUpperCase().indexOf('CAM') > -1) {
                var url = value.thumbnail;
                value.thumbnail = environment.apiBaseUrl + "/camera" + url.substring(url.toUpperCase().indexOf('CAM') - 1, url.length);
            }
            this._document = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocSourceVideoComponent.prototype, "currentFeature", {
        get: function () {
            return this._currentFeature;
        },
        set: function (value) {
            this._currentFeature = JSONConverter(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocSourceVideoComponent.prototype, "altText", {
        get: function () {
            return [this.document.title, this.document.description].filter(function (x) { return x; }).join(' - ') || 'Video';
        },
        enumerable: true,
        configurable: true
    });
    DocSourceVideoComponent.prototype.requestLargerImage = function () {
        if (this.document) {
            this.documentService.requestFullScreenImages([this.document]);
        }
    };
    DocSourceVideoComponent.prototype.requestLargerVideo = function () {
        if (this.document) {
            this.documentService.requestFullScreenVideo(this.document);
            this.video.pause();
        }
    };
    DocSourceVideoComponent.prototype.toggleCamera = function () {
        var _this = this;
        this.showCameraVideo = !this.showCameraVideo;
        if (this.showCameraVideo) {
            setTimeout(function () { _this.initializeHls(); }, 50);
        }
    };
    DocSourceVideoComponent.prototype.ngAfterViewInit = function () {
        if (this.showCameraVideo && this.document.url) {
            this.initializeHls();
        }
    };
    DocSourceVideoComponent.prototype.initializeHls = function () {
        var _this = this;
        if (this.document && this.document.url) {
            this.video = this.videoPlayer.nativeElement;
            var canPlayNatively = this.video.canPlayType('application/vnd.apple.mpegURL') !== '';
            if (!canPlayNatively) {
                if (this.hls) {
                    this.hls.destroy();
                }
                if (Hls.isSupported()) {
                    this.hls = new Hls();
                    this.hls.loadSource(this.document.url.toString());
                    this.hls.attachMedia(this.video);
                    this.hls.on(Hls.Events.MANIFEST_PARSED, function () {
                        _this.video.muted = true;
                        _this.video.play();
                    });
                }
            }
            else {
                this.video.src = this.document.url;
                this.video.load();
            }
        }
    };
    tslib_1.__decorate([
        InputConverter(JSONConverter),
        tslib_1.__metadata("design:type", Object),
        tslib_1.__metadata("design:paramtypes", [Object])
    ], DocSourceVideoComponent.prototype, "currentFeature", null);
    return DocSourceVideoComponent;
}(BaseComponent));
export { DocSourceVideoComponent };
